import cn from 'classnames';
import type { FormEvent, ReactNode } from 'react';
import styles from './SearchPanelWrapper.module.css';

interface SearchPanelWrapperProps {
    onSubmit: (event: FormEvent<HTMLFormElement>) => void;
    action?: string;
    method?: 'GET' | 'POST';
    className?: string;
    dataTestId?: string;
    compactTop?: boolean;
    children: ReactNode;
}

export const SearchPanelWrapper = ({ onSubmit, action, method, className, children, dataTestId, compactTop }: SearchPanelWrapperProps) => (
    <form
        autoComplete="off"
        onSubmit={onSubmit}
        className={cn(styles.form, { [styles.heroBannerSpacer]: !compactTop }, className)}
        action={action}
        method={method}
        data-testid={dataTestId}>
        {children}
    </form>
);
